import { useEffect, useState } from 'react';

const shapeNow = () => (window.innerWidth < window.innerHeight ? 'portrait' : 'landscape');

// The shape of the screen this page is shown on, so the server can leave out ads made for the other shape.
// Each kiosk screen is its own window, so a dual-screen kiosk gets a list per screen.
export const useScreenShape = () => {
    const [shape, setShape] = useState(shapeNow);

    useEffect(() => {
        const update = () => setShape(shapeNow());
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    return shape;
};
